import useMerchandiseCategories from 'hooks/Merchandise/useMerchandiseCategories'
import useMerchandiseCategory from 'hooks/Merchandise/useMerchandiseCategory'
import { capitalise } from 'lib/string/stringUtils'
import React, { useMemo } from 'react'
import MerchandiseBreadcrumbsSection from '../MerchandiseBreadcrumbsSection'
import { getMerchandiseCategorySearchUrl } from '../merchandiseUtils'
import { take } from 'lib/array/arrayUtils'

interface BreadCrumb {
  label: string
  to?: string
}

interface Props {
  offer: App.MerchandiseOffer
  alwaysExpand?: boolean
}

function MerchandiseOfferPageBreadcrumbs(props: Props) {
  const { offer, alwaysExpand } = props

  const [category, fetchingCategory] = useMerchandiseCategory({ id: offer.category?.id })
  const [ancestorCategories, fetchingAncestorCategories] = useMerchandiseCategories({ categoryIds: category?.ancestors.map(ancestor => ancestor.id) })

  const fetchingCategoryData = fetchingCategory || fetchingAncestorCategories

  const breadCrumbs = useMemo<Array<BreadCrumb>>(() => {
    const crumbs: Array<BreadCrumb> = []
    if (category) {
      // We don't want the list of categories getting too long
      // so at most we'll the highest 2 ancestors
      take(ancestorCategories.toReversed(), 2).forEach(ancestor => {
        crumbs.push({
          label: capitalise(ancestor.name),
          to: getMerchandiseCategorySearchUrl(ancestor),
        })
      })
      crumbs.push({
        label: category.name,
        to: getMerchandiseCategorySearchUrl(category),
      })
    }
    crumbs.push({
      label: offer.name,
    })

    return crumbs
  }, [ancestorCategories, category, offer.name])

  return <MerchandiseBreadcrumbsSection
    breadcrumbs={breadCrumbs}
    loading={fetchingCategoryData}
    alwaysExpand={alwaysExpand}
  />
}

export default MerchandiseOfferPageBreadcrumbs
